import { useFormikContext } from 'formik'
import type { LeadAssignmentRuleFormModel } from '../../typings'
import { useMemo } from 'react'

export function useData() {
  const {
    values: { assignmentRuleConditions },
    errors,
    touched,
  } = useFormikContext<LeadAssignmentRuleFormModel>()

  const assignmentRuleConditionsSelectedAttributes = useMemo(
    () => assignmentRuleConditions.map((condition) => condition.attribute),
    [assignmentRuleConditions],
  )

  return {
    assignmentRuleConditions,
    errors,
    touched,
    assignmentRuleConditionsSelectedAttributes,
  }
}
